import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import { api, unwrap } from '@/shared/api/client';
import { STALE } from '@/shared/api/stale';

export interface ReportRunParams {
  period: string;
  asAt?: string | undefined;
}

export const reportKeys = {
  all: ['reports'] as const,
  catalogue: ['reports', 'catalogue'] as const,
  result: (key: string, p: ReportRunParams) => ['reports', 'result', key, p.period, p.asAt ?? null] as const,
  trend: (key: string, period: string) => ['reports', 'trend', key, period] as const,
};

export const reportsQuery = queryOptions({
  queryKey: reportKeys.catalogue,
  queryFn: ({ signal }) => unwrap(api.GET('/reports', { signal })),
  staleTime: STALE.reference,
});

/** A report run is computed as at a moment; list stale rules, previous result kept while the period changes. */
export const reportQuery = (key: string, p: ReportRunParams) =>
  queryOptions({
    queryKey: reportKeys.result(key, p),
    queryFn: ({ signal }) => unwrap(api.GET('/reports/{reportKey}', { params: { path: { reportKey: key }, query: { period: p.period, ...(p.asAt ? { asAt: p.asAt } : {}) } }, signal })),
    staleTime: STALE.list,
    placeholderData: keepPreviousData,
  });

/** Chart series: the report's headline figures for the six months ending at the period (period reports only). */
export const reportTrendQuery = (key: string, period: string) =>
  queryOptions({
    queryKey: reportKeys.trend(key, period),
    queryFn: ({ signal }) => unwrap(api.GET('/reports/{reportKey}/trend', { params: { path: { reportKey: key }, query: { period, periods: 6 } }, signal })),
    staleTime: STALE.list,
    placeholderData: keepPreviousData,
  });
